<template>
  <v-layout 
  justify-center
  pt-5
  mt-4
  pb-3>
    <v-flex
      xs6 
      
    >
   <p class="header-2"> Password changed successfully! </p>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState } from "vuex";
import { STRONG_COLOR } from "@/components/globals/consts";
import rmp_tagline from '@/assets/rmp_tagline.png'
import AuthenticationService from '@/services/AuthenticationService'

export default {
  data() {
    return {
      strongColor: STRONG_COLOR,
      email: null
    }
  },
  computed: {
    ...mapState(["isUserLoggedIn", "user"])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PasswordChanged.vue